export default __webpack_public_path__ + "static/media/Flag_of_New_Zealand.0fb39b02.svg";